export default __webpack_public_path__ + "static/media/logo-sem-fundo-site.b09648f3.png";